<template>
    <div>
        <!-- begin panel-heading -->
        <template slot="header">
            <h4 class="panel-title">{{ $route.params.type | capitalize }}</h4>
        </template>
        <!-- end panel-heading -->
        <div class="row">
            <div class="col-xl-9 col-lg-8 m-b-10">
                <b-card no-body>
                    <b-list-group flush v-if="!onlySubcategories">
                        <b-list-group horizontal>
                            <b-list-group-item class="col p-0"><b-button squared block variant="white-outlined" class="text-left">Image</b-button></b-list-group-item>
                            <b-list-group-item class="col p-0">
                                <b-button squared block variant="white-outlined" class="text-left" @click="ascendingSort = !ascendingSort">
                                    <i class="fa fa-sort text-grey" />
                                    Name
                                </b-button>
                            </b-list-group-item>
                            <b-list-group-item class="col p-0"><b-button squared block variant="white-outlined" class="text-left">Actions</b-button></b-list-group-item>
                        </b-list-group>
                        <b-list-group-item class="no-indent" v-for="category in this.categoriesInType(null)" :key="category.id">
                            <div class="row">
                                <span class="col">
                                    <button v-if="category.children.length == 0" class="btn btn-default btn-icon btn-circle btn-lg m-30">
                                        <i class="fa fa-circle" />
                                    </button>
                                    <button v-else class="btn btn-default btn-icon btn-circle btn-lg m-30" v-b-toggle="'collapse-' + category.id">
                                        <i class="when-closed fa fa-chevron-right" />
                                        <i class="when-open fa fa-chevron-down" />
                                    </button>
                                    <img class="m-b-10" :src="getImage(category.image)" height="65px" />
                                </span>
                                <span class="col">{{ category.name }}</span>
                                <span class="col"><url-button label="View details" :url="`/eventbank/${$route.params.type}/categories/` + category.id" class="btn-yellow" /></span>
                            </div>
                            <b-collapse :visible="visible" :id="'collapse-' + category.id">
                                <b-list-group>
                                    <b-list-group-item class="no-indent" v-for="childCategory in categoriesInType(category.id)" :key="childCategory.id">
                                        <div class="row">
                                            <span class="col">
                                                <button class="btn btn-default btn-icon btn-circle btn-lg m-30">
                                                    <i class="fa fa-circle" />
                                                </button>
                                                <img class="m-b-10 m-l-20" :src="getImage(childCategory.image)" height="65px" />
                                            </span>
                                            <span class="col">{{ childCategory.name }}</span>
                                            <span class="col"><url-button label="View details" :url="`/eventbank/${$route.params.type}/categories/` + childCategory.id" class="btn-yellow" /></span>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-collapse>
                        </b-list-group-item>
                    </b-list-group>
                    <b-list-group flush v-else>
                        <b-list-group horizontal>
                            <b-list-group-item class="col p-0"><b-button squared block variant="white-outlined" class="text-left">Image</b-button></b-list-group-item>
                            <b-list-group-item class="col p-0">
                                <b-button squared block variant="white-outlined" class="text-left" @click="ascendingSort = !ascendingSort">
                                    <i class="fa fa-sort text-grey" />
                                    Name
                                </b-button>
                            </b-list-group-item>
                            <b-list-group-item class="col p-0"><b-button squared block variant="white-outlined" class="text-left">Actions</b-button></b-list-group-item>
                        </b-list-group>
                        <b-list-group-item class="no-indent" v-for="childCategory in categoriesInType(0)" :key="childCategory.id">
                            <div class="row">
                                <span class="col">
                                    <button class="btn btn-default btn-icon btn-circle btn-lg m-30">
                                        <i class="fa fa-circle" />
                                    </button>
                                    <img class="m-b-10" :src="getImage(childCategory.image)" width="100px" />
                                </span>
                                <span class="col">{{ childCategory.name }}</span>
                                <span class="col"><url-button label="View details" :url="`/eventbank/${$route.params.type}/categories/` + childCategory.id" class="btn-yellow" /></span>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </div>
            <div class="col-xl-3 col-lg-4">
                <b-card no-body>
                    <b-card-header header-tag="header" class="p-0" role="tab">
                        <b-button block v-b-toggle.tab1 variant="light">Filters</b-button>
                    </b-card-header>
                    <b-collapse id="tab1" visible role="tabpanel">
                        <b-card-body>
                            <label class="width-full"><b>Search:</b>
                                <input v-model="search" placeholder="Search categories" type="search" class="form-control" @input="collapse" />
                            </label>
                            <label class="width-full"><b>Level filter:</b>
                                <b-form-checkbox switch v-model="onlySubcategories" @change="updateValues">Only {{ levelValue }}</b-form-checkbox>
                            </label>
                            <label v-if="onlySubcategories" class="width-full"><b>{{ parentValue }}</b>
                                <select v-model="parentCategory" class="form-control">
                                    <option value="all">All</option>
                                    <option v-for="category in this.categoriesInType(null)" :key="category.id" :value="category.id">{{ category.name }}</option>
                                </select>
                            </label>
                            <input-button type="button" @click="resetFilters" label="Reset filters" class="btn-yellow mt-2" />
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
        </div>
        <div class="height-50">
            <hr/>
            <url-button label="Create new" :url="$route.path + '/new'" class="btn-yellow pull-right" />
        </div>
    </div>
    <!-- end panel -->
</template>

<script>
import UrlButton from '../buttons/UrlButton.vue'
import InputButton from '../buttons/InputButton.vue'

export default {
    name: 'CategoryTable',
    props: ['typeId', 'categories'],
    components: {
        UrlButton,
        InputButton
    },
    data() {
        return {
            ascendingSort: true,
            search: '',
            onlySubcategories: false,
            levelValue: 'areas',
            visible: false,
            parentValue: '',
            parentCategory: 'all'
        }
    },
    mounted() {
        this.updateValues();
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    methods: {
        getImage(image) {
            if (image == null) {
                return require('../../assets/images/no_image.jpg');
            } else {
                return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd;
            }
        },
        categoriesInType(parent) {
            let self = this;
            let hideParents = this.onlySubcategories;
            
            let filteredCategories = this.categories.filter(function (category) {
                if (hideParents && parent == 0) {
                    if (category.type.id === self.typeId && category.parent) {
                        if (category.parent.id == self.parentCategory || self.parentCategory == 'all') {
                            if (category.name.toLowerCase().includes(self.search.toLowerCase())) {
                                return category;
                            }
                        }
                    }
                } else {
                    if (category.parent === null) {
                        if (category.type.id === self.typeId && category.parent === parent) {
                            let returnable = null;
                            if (category.name.toLowerCase().includes(self.search.toLowerCase())) {
                                return category;
                            } else if (category.children.length) {
                                category.children.forEach(child => {
                                    if (child.name.toLowerCase().includes(self.search.toLowerCase())) {
                                        returnable = category;
                                    }
                                });
                                return returnable;
                            }
                        }
                    } else {
                        if (category.type.id === self.typeId && category.parent.id === parent) {
                            if (category.name.toLowerCase().includes(self.search.toLowerCase())) {
                                return category;
                            }
                        }
                    }
                }
            });

            filteredCategories.sort(function(a, b) {
                if (self.ascendingSort) {
                    if (a.name < b.name) { return -1; }
                    if (a.name > b.name) { return 1; }
                    return 0;
                } else {
                    if (a.name > b.name) { return -1; }
                    if (a.name < b.name) { return 1; }
                    return 0;
                }
            });
            return filteredCategories;
        },
        updateValues() {
            switch (this.typeId) {
                case 1:
                    this.levelValue = "areas";
                    this.parentValue = "Categories:";
                    break;
                case 2:
                    this.levelValue = "areas";
                    this.parentValue = "Venues:";
                    break;
                case 3:
                    this.levelValue = "teams";
                    this.parentValue = "Groups:";
                    break;
                case 4:
                    this.levelValue = "subcategories";
                    this.parentValue = "Categories:";
                    break;
                default:
                    break;
            }
        },
        collapse() {
            if (this.search == '') {
                this.visible = false;
            } else {
                this.visible = true;
            }
        },
        resetFilters() {
            this.search = '';
            this.onlySubcategories = false;
            this.parentCategory = 'all';
            this.collapse();
        }
    },
    watch: {
        $route () {
            this.updateValues();
            this.search = '';
            this.parentCategory = 'all';
            this.collapse();
        }
    }
}
</script>